export const maxFeePercentage = 0.0024
export const feeDivisor = 10000 // Fees come from backend as e.g. 24 = 0.24%
